import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { MeetingRoomComponent } from './meeting-room/meeting-room.component';
import { VideoRoomComponent } from './video-room/video-room.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LogoutComponent } from './logout/logout.component';
import { JoinMeetingComponent } from './join-meeting/join-meeting.component';
import { StartMeetingComponent } from './start-meeting/start-meeting.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { WebinarComponent } from './webinar/webinar.component';
import { ContactComponent } from './contact/contact.component';
import { ConferencescheduleComponent } from './conferenceschedule/conferenceschedule.component';
import { LivewebinarComponent } from './livewebinar/livewebinar.component';
import { OfflinewebinarComponent } from './offlinewebinar/offlinewebinar.component';
import { ProfileComponent } from './profile/profile.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { StartmeetingComponent } from './startmeeting/startmeeting.component';
import { JoinmeetingComponent } from './joinmeeting/joinmeeting.component';
import { VideooromComponent } from './videoorom/videoorom.component';
import { VideoroommeetingComponent } from './videoroommeeting/videoroommeeting.component';
// import { ConferenceComponent } from './conference/conference.component';


const routes: Routes = [
	{ path: 'home', component: HomeComponent },
	{ path: 'dashboard', component: DashboardComponent },
	{ path: 'startMeeting', component: StartMeetingComponent },
	{ path: 'joinMeeting', component: JoinMeetingComponent },
	{ path: 'logout', component: LogoutComponent },
	{ path: 'schedule', component: ScheduleComponent },
	// { path: 'meeting/:roomName', component:MeetingRoomComponent },
	{path:'webinar', component:WebinarComponent},
	{path:'contact', component:ContactComponent},
	{path:'conferenceschedule', component:ConferencescheduleComponent},
	{path:'livewebinar', component:LivewebinarComponent},
	{path:'offlinewebinar', component:OfflinewebinarComponent},
	{path:'profile', component:ProfileComponent},
	{path:'feedback', component:FeedbackComponent},
	{path:'startmeeting', component:StartmeetingComponent},
	{path:'joinmeeting', component:JoinmeetingComponent},
	/*{ path: ':roomName', component: VideoRoomComponent },*/
	{ path: 'videoorom', component: VideooromComponent },
	// {path:'conference', component:ConferenceComponent},
	{ path: 'videoroommeeting/:id', component: VideoroommeetingComponent },
	{ path: '', component: LoginComponent }

];

@NgModule({
	imports: [RouterModule.forRoot(routes, { useHash: true })],
	exports: [RouterModule]
})
export class AppRoutingModule {}
